export default {"arrow":"_5b7Xl","open":"iiFLv","arrowIcon":"PXCdx"};